import { globalHistory } from '@reach/router'

const usePathname = () =>
  globalHistory.location.pathname.split('/').filter(path => path) || []

export default usePathname
